export default __webpack_public_path__ + "assets/images/coins.54ba29.png";